import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TerminalProfile } from './terminal-payment.service';

export interface TerminalProfileSelectDialogData {
  profiles: TerminalProfile[];
}

@Component({
  selector: 'app-terminal-profile-select-dialog',
  template: `
    <h2 mat-dialog-title>Выберите терминал</h2>
    <mat-dialog-content class="terminal-profile-list">
      <button
        mat-stroked-button
        type="button"
        *ngFor="let profile of data.profiles; trackBy: trackProfile"
        (click)="select(profile)"
      >
        <span>{{ profile.label }}</span>
        <small>
          TID {{ profile.terminalId }} · {{ profile.provider }} · склад #{{ profile.warehouseId }}
        </small>
      </button>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="dialogRef.close(null)">Отмена</button>
    </mat-dialog-actions>
  `,
  styles: [
    `
      .terminal-profile-list {
        display: grid;
        gap: 8px;
        min-width: min(420px, 80vw);
        padding-top: 8px;
      }
      .terminal-profile-list button {
        height: auto;
        padding: 10px 14px;
        text-align: left;
      }
      .terminal-profile-list button span,
      .terminal-profile-list button small {
        display: block;
      }
      .terminal-profile-list button small {
        color: #667085;
        margin-top: 2px;
      }
    `
  ]
})
export class TerminalProfileSelectDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TerminalProfileSelectDialogData,
    public dialogRef: MatDialogRef<TerminalProfileSelectDialogComponent>
  ) {}

  trackProfile(_: number, profile: TerminalProfile) {
    return profile.id;
  }

  select(profile: TerminalProfile) {
    this.dialogRef.close(profile);
  }
}
